import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'overAllSalesReportPojo'
})
export class OverAllSalesReportPojoPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return null;
  }

}
